import './swiper_configs.js';
import './sticky-anchor-bar.js';
import './main.js';
import './enhanced-ecommerce.js';
import './clickable-div.js';
import countdown from './countdown';

try {
    // safety loader
    if (!window.$) {
        window.$ = window.jQuery = require('jquery');
    }

    jQuery(function() {
        countdown();
    });
}
catch (e) {}
